import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

export default function TransitionIn(props) {
  const initialHeight = props.initialHeight || 0;
  const [height, setHeight] = useState(initialHeight);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref || !ref.current) return;
    const h = ref.current.offsetHeight;
    setHeight(h);
  }, [ref && ref.current && ref.current.offsetHeight]);

  return (
    <div
      style={{
        position: "relative",
        height: height,
        width: "100%",
        transition: "height 0.7s ease-out",
      }}>
      <div style={{ position: "absolute", width: "100%" }}>
        <div ref={ref}>{props.children}</div>
      </div>
    </div>
  );
}

TransitionIn.propTypes = {
  children: PropTypes.node,
  initialHeight: PropTypes.number,
};
